import { useNavigate } from 'react-router-dom';
import styles from './ReturnToDashboard.module.css';
import { useLogo } from '../../hooks/LogoContext';
import { useModal } from '../../hooks/modalContext';

const ReturnToDashboard = () => {
  const { logoUrl, logoLoading } = useLogo();
  const { setModal } = useModal();
  const navigate = useNavigate();
  const handleYes = () => {
    setModal(null);
    navigate('/dashboard');
  };

  const handleNo = () => {
    setModal(null); // Close the modal
  };

  return (
    <main className={styles.main}>
      <section className={styles.section}>
        <div className={styles.message}>
          {!logoLoading && <img src={logoUrl} className={styles.logo} alt='logo' />}
          <h2 className={styles.heading}>
            Are you sure you want to leave this page and return to the dashboard?
          </h2>

          <div className={styles.buttonGroup}>
            <button className={styles.closeBtn} onClick={handleYes}>
              Yes
            </button>
            <button className={styles.closeBtn} onClick={handleNo}>
              No
            </button>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ReturnToDashboard;
